module.exports = __webpack_public_path__ + "media/recipes/critical-photons-0be8278f.png";